import { gsap, Power2 }  from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const responsiveWidth = 1200
const menu = document.querySelector('#nav nav')
const toggleMenu = document.querySelector('#nav .togglenav')
const toggleMenuLine = document.querySelector('#nav .togglenav line')
const toggleMenuLineColor = gsap.getProperty(toggleMenuLine, 'stroke')
const toggleItems = document.querySelectorAll('#nav li.menu-item-has-children')

toggleMenu.addEventListener('click', () =>
{
	const isMenuOpen = gsap.getProperty(menu, 'visibility') === 'visible'
	
	gsap.to(toggleMenu.querySelector('line:nth-of-type(1)'), {
		attr: { x1: isMenuOpen ? 1 : 2, x2: isMenuOpen ? 7 : 6, y2: isMenuOpen ? 1 : 5, stroke: isMenuOpen ? toggleMenuLineColor : '#fff' },
		duration: .5,
		ease: Power2.easeOut
	})
	
	gsap.to(toggleMenu.querySelector('line:nth-of-type(2)'), {
		attr: { x1: isMenuOpen ? 1 : 4, x2: isMenuOpen ? 7 : 4 },
		opacity: isMenuOpen ? 1 : 0,
		duration: .5,
		ease: Power2.easeOut
	})
	
	gsap.to(toggleMenu.querySelector('line:nth-of-type(3)'), {
		attr: { x1: isMenuOpen ? 1 : 2, x2: isMenuOpen ? 7 : 6, y2: isMenuOpen ? 5 : 1, stroke: isMenuOpen ? toggleMenuLineColor : '#fff' },
		duration: .5,
		ease: Power2.easeOut
	})
	
	gsap.to(menu, {
		opacity: isMenuOpen ? 0 : 1,
		duration: .5,
		ease: Power2.easeOut,
		onStart: () =>
		{
			if (!isMenuOpen)
			{
				gsap.set(menu, { visibility: 'visible' })
			}
		},
		onComplete: () =>
		{
			if (isMenuOpen)
			{
				gsap.set(menu, { visibility: 'hidden' })
			}
		}
	})
})

toggleItems.forEach(el =>
{
	let toggleSubnav = el.querySelector('.toggle_subnav')
	
	if (!toggleSubnav)
	{
		toggleSubnav = document.createElement('div')
		toggleSubnav.className = 'toggle_subnav'
		
		el.appendChild(toggleSubnav)
	}
	
	if (window.innerWidth > responsiveWidth)
	{
		return
	}
	
	toggleSubnav.addEventListener('click', (e) =>
	{
		e.preventDefault()
		
		const li = el.closest('li')
		const ul = li.querySelector('ul')
		
		/*if (e.target !== e.currentTarget)
		{
			return
		}*/
		
		Array.from(toggleItems).filter(item => item !== li).forEach(_el =>
		{
			gsap.to(_el.querySelector('ul'), {
				height: 0,
				duration: .5,
				ease: Power2.easeOut
			})
			
			_el.classList.remove('open')
		})
		
		if (li.classList.contains('open'))
		{
			li.classList.remove('open')
			
			gsap.to(ul, {
				height: 0,
				duration: .5,
				ease: Power2.easeOut
			})
		}
		else
		{
			li.classList.add('open')
			
			gsap.set(ul, {
				display: 'block',
				height: 0
			})
			
			gsap.to(ul, {
				height: 'auto',
				duration: .5,
				ease: Power2.easeOut
			})
		}
	})
})

const nav = document.querySelector('#nav')
const fixNavOffset = nav.clientHeight + 'px'

ScrollTrigger.create({
	start: fixNavOffset,
	end: 99999,
	/*toggleClass: {
	 className: 'fixed',
	 targets: '#nav'
	 },*/
	onEnter: () =>
	{
		nav.classList.add('fixed')
		document.body.style.paddingTop = fixNavOffset
	},
	onLeaveBack: () =>
	{
		nav.classList.remove('fixed')
		document.body.style.paddingTop = '0'
	}
})

/*window.addEventListener('scroll', () =>
 {
 if (window.scrollY > fixNavOffset)
 {
 nav.classList.add('fixed')
 document.body.style.paddingTop = fixNavOffset + 'px'
 }
 else
 {
 nav.classList.remove('fixed')
 document.body.style.paddingTop = '0px'
 }
 })*/
